import { MODAL } from '../types';

const initialState = {
  data: {},
  showModal: false,
};

const cashFlowModalReducer = (state = initialState, action) => {
  switch (action.type) {
    case MODAL.SWITCH_CASH_FLOW_MODAL:
      return {
        data: action.payload,
        showModal: !state.showModal,
      };

    default:
      return state;
  }
};

export default cashFlowModalReducer;
